import type { ReactNode } from 'react'
import type { ReviewComment } from './contracts'

// Inline critique flag (spec §8.2): every *visible* critique renders a
// dashed red strip inside its target section. Deliberately derived off the
// comment itself rather than authored/state-tracked separately — dismissing
// the comment (status -> 'dismissed') makes this component render nothing,
// which is what makes "dismiss removes the card AND its CritiqueFlag" true
// without any extra wiring from the caller.

const EXCERPT_LIMIT = 90

function excerptOf(body: string): string {
  return body.length > EXCERPT_LIMIT ? `${body.slice(0, EXCERPT_LIMIT)}…` : body
}

export function CritiqueFlag(props: { comment: ReviewComment }): ReactNode {
  const { comment } = props
  if (comment.kind !== 'critique' || comment.status === 'dismissed') {
    return null
  }

  return (
    <div
      className="mb-2 flex flex-wrap items-center gap-2.5 rounded-lg border border-dashed px-3 py-1.5"
      style={{
        background: 'color-mix(in oklab, var(--cd-red) 5%, transparent)',
        borderColor: 'color-mix(in oklab, var(--cd-red) 35%, transparent)',
      }}
    >
      <span className="shrink-0 text-[10px] font-bold text-(--cd-red)">
        ✦ CRITIQUE
      </span>
      <span
        className="shrink-0 rounded-full border border-(--cd-border-2) px-2 py-0.5 text-[10.5px] font-semibold text-(--cd-text-muted)"
        style={{
          background: 'color-mix(in oklab, var(--cd-bg) 50%, transparent)',
        }}
      >
        {comment.target}
      </span>
      <span className="min-w-[200px] flex-1 text-xs leading-snug text-(--cd-text-2)">
        {excerptOf(comment.body)}
      </span>
      <span className="shrink-0 text-[10.5px] text-(--cd-text-faint)">
        → margin comment
      </span>
    </div>
  )
}
